import axios from 'axios';
import { environment } from 'src/environments/environment';

export function setupAxiosSecurity() {
  // 1. Interceptor de solicitudes de Axios: Inyectar Authorization: Bearer <token>
  axios.interceptors.request.use(
    (config) => {
      const isLogin = config.url && config.url.includes('/auth/login');
      if (!isLogin) {
        const token = localStorage.getItem('AuthToken');
        if (token) {
           // config.headers = config.headers || {};
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }

      // Timeout por defecto: 15s estándar, 30s pesado
      if (!config.timeout) {
        const isHeavy = config.url && (config.url.includes('/facturacion') || config.url.includes('/pdf'));
        config.timeout = isHeavy ? 30000 : 15000;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  // 2. Interceptor de respuestas de Axios: Manejar 401 y 403
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        console.warn(`[AxiosSecurity] Error ${status} detectado. Purgando sesión y redirigiendo.`);
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
}
